<template>
  <div class="card">
    <!-- @slot header do accordion -->
    <slot name="header">
      <a class="font-weight-bold" @click="toogle" href="javascript:void(0)">
        <div class="card-header" id="headingDados">
          <h5 class="mb-0 mt-4 font-weight-bold float-left">{{ titulo }}</h5>
          <i class="material-icons float-right mt-4">{{
            isOpenLocal ? "keyboard_arrow_up" : "keyboard_arrow_down"
          }}</i>
        </div>
      </a>
    </slot>


      <div v-if="isOpenLocal" ref="conteudo" >
        <!-- @slot Conteudo -->
        <slot></slot>
      </div>

  </div>
</template>

<script>
export default {
  /**
   * Item de um accordion
   */
  name: "AccordionItem",
  model: {
    event: 'tootle',
    prop: 'isOpen'
  },
  props: {
    /**
     * Titulo do accordion.
     */
    titulo: {
      type: String
    },
    /**
     * Define se está aberto.
     * @values true, false
     */
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  inject: ['addAccordion', 'removeAccordion',  'onToogle'],
  watch: {
    isOpen(newVal) {
      this.isOpenLocal = newVal;
    }
  },
  data() {
    return {
      isOpenCollapse: this.isOpen,
      isOpenLocal: this.isOpen
    };
  },
  methods: {
    toogle(force) {

      let val = this.isOpenLocal
      if ( typeof force === "boolean"  ) {
        val = !force
      }

      // uso do setTimeout para animacao funcionar com o v-if
      if( val ){
        this.isOpenCollapse = false
        setTimeout(() => {  this.isOpenLocal = false } , 0)
      }else{
        this.isOpenLocal = true
        setTimeout(() => {  this.isOpenCollapse = true  } , 0)
      }

      /**
       * Toogle event. dispara ao abrir ou fechar o accordionItem
       *
       * @event toogle
       * @property {boolean} true para aberto false para fechado
       */
      this.$emit("toggle", this.isOpenLocal);
      if( typeof force !== "boolean"  ) {
        this.onToogle(this)
      }
    }
  },
  mounted () {
    this.addAccordion(this)
  },
  destroyed () {
    this.removeAccordion(this)
  }
};
</script>
